module.exports = __webpack_public_path__ + "media/legendary.ea56ad96.mp4";